import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppInitializerService } from '@app/app-initializer.service';
import { GlobalFunctionService } from '@app/system/services/global-function.service';

@Injectable({
	providedIn: 'root'
})
export class ApiService {

	headers: any = {
		'Content-Type': 'application/json'
	};

	constructor(
		private http: HttpClient,
		private gfService: GlobalFunctionService,
		private appInit: AppInitializerService
	) { }

	assignToMe(params: any = {}, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api =
			this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `assignment/for_me`;
		const options = {
			headers: new HttpHeaders(headers),
			params
		};
		return this.http.get(api, options);
	}

	assignByMe(params: any = {}, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api =
			this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `assignment/by_me`;
		const options = {
			headers: new HttpHeaders(headers),
			params
		};
		return this.http.get(api, options);
	}

	myWorkgroupAssignment(params: any = {}, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api =
			this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `assignment/myworkgroup`;
		const options = {
			headers: new HttpHeaders(headers),
			params
		};
		return this.http.get(api, options);
	}

	submit(params: any = {}, id, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		const api =
			this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `assignment/submit/${id}`;
		headers = this.gfService.JSONMerge(headers, this.headers);
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.put(api, params, options);
	}

	abort(params: any = {}, id, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		const api =
			this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `assignment/abort/${id}`;
		headers = this.gfService.JSONMerge(headers, this.headers);
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.put(api, params, options);
	}

	reassign(params: any = {}, id, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		const api =
			this.appInit.configuration.API_URL +
			'' +
			this.appInit.configuration.API_PREFIX +
			`assignment/reassign/${id}`;
		headers = this.gfService.JSONMerge(headers, this.headers);
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.put(api, params, options);
	}

	evaluate(params: any = {}, id, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		const api =
			this.appInit.configuration.API_URL +
			'' +
			this.appInit.configuration.API_PREFIX +
			`assignment/evaluate/${id}`;
		headers = this.gfService.JSONMerge(headers, this.headers);
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.put(api, params, options);
	}

	getResourceForMe(id: number, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api =
			this.appInit.configuration.API_URL +
			'' +
			this.appInit.configuration.API_PREFIX +
			`assignment/by_resource/for_me/${id}`;
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.get(api, options);
	}

	getResourceByMe(id: number, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api =
			this.appInit.configuration.API_URL +
			'' +
			this.appInit.configuration.API_PREFIX +
			`assignment/by_resource/by_me/${id}`;
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.get(api, options);
	}

	getAssignment(id: number, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api =
			this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `assignment/${id}`;
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.get(api, options);
	}

	getHistory(id: number, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api =
			this.appInit.configuration.API_URL +
			'' +
			this.appInit.configuration.API_PREFIX +
			`assignment/history/${id}`;
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.get(api, options);
	}

	add(params: any = {}, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `assignment`;
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.post(api, params, options);
	}

	getWorkgroupIsMember(params: any, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api =
			this.appInit.configuration.API_URL +
			'' +
			this.appInit.configuration.API_PREFIX + `workgroups/ismember`;
		const options = {
			headers: new HttpHeaders(headers),
			params
		};
		return this.http.get(api, options);
	}
}
